<template>
  <div class="container mt-4">
    <h3 class="title">{{ $t("settings") }}</h3>
    <!-- <div class="tabs is-toggle is-fullwidth" ref="tabs">
      <ul>
        <li class="is-active" data-tab="access" @click="change_active_tab">
          <a>
            <i class="lock icon" aria-hidden="true"></i>
            <span>{{ $t("access") }}</span>
          </a>
        </li>
        <li class="is-active" data-tab="system" @click="change_active_tab">
          <a>
            <i class="settings icon" aria-hidden="true"></i>
            <span>{{ $t("system") }}</span>
          </a>
        </li>
        <li data-tab="modules" @click="change_active_tab">
          <a>
            <i class="cubes icon" aria-hidden="true"></i>
            <span>{{ $t("modules") }}</span>
          </a>
        </li>
      </ul>
    </div> -->
    <div class="container" ref="contents">
      <!-- <access class="" data-tab="access" /> -->
      <system class="" data-tab="system" />
      <!-- <modules class="is-hidden" data-tab="modules" /> -->
    </div>
  </div>
</template>

<script>
// import Access from "./Access.vue";
import System from "./System.vue";
// import Modules from "./Modules.vue";

export default {
  name: "SettingsView",
  components: { /* Access */ System /* Modules */ },
  data() {
    return {};
  },
  computed: {},
  methods: {
    change_active_tab($event) {
      let v = this;
      let target = $event.target;
      let active_tab = "";
      if (target) active_tab = window.jQuery(target).closest("li").data("tab");
      if (active_tab) {
        /** Headers */
        window.jQuery(v.$refs.tabs).find("li").removeClass("is-active");
        window
          .jQuery(v.$refs.tabs)
          .find(`li[data-tab=${active_tab}]`)
          .addClass("is-active");

        /** Content */
        window.jQuery(v.$refs.contents).find(">div").addClass("is-hidden");
        // .attr("display", "none");
        window
          .jQuery(v.$refs.contents)
          .find(`div[data-tab=${active_tab}]`)
          .removeClass("is-hidden");
      }
    },
  },
  mounted() {
    // window.jQuery(".ui.menu .item").tab();
    // window.jQuery(".tabs.is-toggle li").tab({
    //   onLoad(tabPath) {
    //     console.log(tabPath);
    //   },
    // });
  },
};
</script>

<style></style>
